import { render, staticRenderFns } from "./Pruefungsordnung.vue?vue&type=template&id=8cd7f1a8&scoped=true&"
import script from "./Pruefungsordnung.vue?vue&type=script&lang=js&"
export * from "./Pruefungsordnung.vue?vue&type=script&lang=js&"
import style0 from "./Pruefungsordnung.vue?vue&type=style&index=0&id=8cd7f1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd7f1a8",
  null
  
)

export default component.exports